'use client';

import React from 'react';
import styled from '@benzinga/themetron';

export interface InputProps {
  placeholder?: string;
  onChange: (value: string) => void;
  value?: string;
  label?: string;
}

export const Input: React.FC<InputProps> = ({ label, onChange, placeholder, value }) => {
  const handleChange = React.useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      onChange && onChange(e.target.value);
    },
    [onChange],
  );

  return (
    <Container className="input-container">
      {label && <label htmlFor="core-input">{label}</label>}
      <input id="core-input" onChange={handleChange} placeholder={placeholder} value={value} />
    </Container>
  );
};

export default Input;

const Container = styled.div`
  &.input-container {
    display: flex;
    flex-direction: column;
    label {
      margin-bottom: 0.5rem;
      font-size: ${({ theme }) => theme.fontSize.base};
    }
    input {
      background-color: ${({ theme }) => theme.colors.background};
      border: 1px solid ${({ theme }) => theme.colors.border};
      border-radius: ${({ theme }) => theme.borderRadius.sm};
      font-size: ${({ theme }) => theme.fontSize.base};
      line-height: 1.5rem;
      padding: 0.25rem 0.5rem;
      outline: none;

      &:focus {
        border-color: ${({ theme }) => theme.colorPalette.blue500};
      }
    }
  }
`;
